import React from "react";
import {
  Users,
  Layers,
  Brain,
  PhoneCall,
  Inbox,
  TrendingUp,
  Target,
} from "lucide-react";

import ProductPage from "../Components/ProductPage";
import { colors as DS } from "../../design-system";

export default function ProductRecruit() {
  return (
    <ProductPage
      meta={{ index: "P-02", code: "RECRUIT" }}
      hero={{
        title: (
          <>
            A CRM
            <br />
            <span style={{ color: `${DS.forest}80` }}>for recruiters.</span>
          </>
        ),
        subtitle: "Recruitment CRM",
        description:
          "Pipeline automation, client management and AI-powered sourcing purpose-built for staffing firms and in-house recruitment teams.",
        accent: DS.product.recruit,
        icon: Users,
        animation: "terminal",
        terminalLines: [
          "$ recruit source --icp 'Backend · Berlin'",
          "» searching network + database",
          "✓ 47 strong fits · 3 interviews booked",
        ],
      }}
      features={{
        title: "Pipeline that runs itself between calls.",
        subtitle: "Replace your spreadsheets, your inbox rules and your sticky notes.",
        items: [
          {
            icon: Layers,
            title: "Multi-stage pipelines",
            description: "Drag-and-drop kanbans per client, role and stage with full activity history.",
          },
          {
            icon: Brain,
            title: "AI sourcing",
            description: "LLM-powered Boolean search across your DB and external sources ranked by fit.",
          },
          {
            icon: Target,
            title: "Targets & KPIs",
            description: "Per-recruiter targets, leaderboards and live commission previews.",
          },
          {
            icon: PhoneCall,
            title: "Call & email logging",
            description: "Two-way sync with Gmail/Outlook and click-to-call into Aircall, RingCentral and friends.",
          },
          {
            icon: Inbox,
            title: "Shared client portal",
            description: "Clients see shortlists, leave feedback and approve interviews without email tennis.",
          },
          {
            icon: TrendingUp,
            title: "Revenue attribution",
            description: "Every placement traced to a source, recruiter and campaign paid before payday.",
          },
        ],
      }}
      flow={{
        title: "Source, place, repeat at scale.",
        stages: [
          { title: "Source",   desc: "AI search + ICP-based candidate sourcing across networks." },
          { title: "Engage",   desc: "Sequenced outreach with templated and AI-generated messages." },
          { title: "Submit",   desc: "Shortlists, scorecards and one-click client submissions." },
          { title: "Place",    desc: "Offer, sign-off and revenue attribution baked in." },
        ],
      }}
      stats={{
        title: "What top recruiters ship per quarter.",
        items: [
          { value: "2.4×", label: "more placements per rec" },
          { value: "−38%", label: "time spent on data entry" },
          { value: "92%",  label: "client satisfaction" },
          { value: "12 d",  label: "median submit-to-offer" },
        ],
      }}
      ctaPrimary={{ label: "Request demo",     href: "/contact" }}
      ctaSecondary={{ label: "Open Recruit",   href: "/recruit/auth" }}
      finalCta={{
        title: (
          <>
            More placements.
            <br />
            <span style={{ color: `${DS.forest}80` }}>Less admin.</span>
          </>
        ),
        subtitle: "Replace 4 SaaS tools with one. Onboard your team in a day.",
        ctaPrimary:   { label: "Talk to sales",     href: "/contact" },
        ctaSecondary: { label: "Explore the suite", href: "/products" },
      }}
    />
  );
}
